type SpinnerSize = 'sm' | 'md' | 'lg';

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
}

const sizeClasses: Record<SpinnerSize, string> = {
  sm: 'h-3 w-3 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-2',
};

export const Spinner = ({ size = 'md', className = '' }: SpinnerProps): JSX.Element => (
  <div
    role="status"
    aria-label="Loading"
    className={`animate-spin rounded-full border-white/10 border-t-indigo-400 ${sizeClasses[size]} ${className}`}
  />
);
